import { GruserType } from '@wix/da-gruser-shared/pkg/types';
import { URLS, Url } from '@wix/da-url';
import { ExhibitionistWidgetType } from './types';
import { isGroup } from '../../User/helpers';
export const getExhibitionistWidgetType = ({ gruser, zone: { name: zoneName } })=>{
    if (gruser.gruserTypeid === GruserType.Deviation) {
        return ExhibitionistWidgetType.STRIP_SHORT;
    } else {
        return zoneName === 'topBar' ? ExhibitionistWidgetType.STRIP : ExhibitionistWidgetType.TALL;
    }
};
export const getSubmitUrlForProfileOwner = (profileOwner)=>{
    return isGroup(profileOwner) ? Url.submissionLinkWithGroupId(profileOwner.userId) : Url.to(URLS.STUDIO);
};

//# sourceMappingURL=helpers.js.map